/* Copyright 2013 - 2024 Waiterio LLC */
import { getContext } from '@monorepo/context/index.js'
import { translateSelector } from '../selectors/LocaleSelectors.js'

export default function translate(text) {
  return translateSelector(getContext())(text)
}
